import 'react-native-get-random-values'; // for crypto-js
import CryptoJS from 'crypto-js';

import * as hf from './_hf';
import * as ht from './_ht';

export const ect = (
  pVle: ht.a, 
  pSrt?: ht.s,
) => {
  if (!pSrt) {
    //hf.l(`cmCPT warning: set srt`)
    return pVle;
  }
  else {
    const _srt = pSrt ?? 'hogehoge';
    return CryptoJS.AES.encrypt(hf.s({tgt: pVle}), _srt).toString(); // not sure, but you have to wrap the value with object and stringify them.
  }
};

export const dct = (
  pVle: ht.a, 
  pSrt?: ht.s,
) => {
  if (!pSrt) {
    //hf.l(`cmCPT warning: set srt`)
    return pVle;
  }
  else {
    const _srt = pSrt ?? 'hogehoge';
    const _s = CryptoJS.AES.decrypt(pVle, _srt).toString(CryptoJS.enc.Utf8);
    return hf.j(_s)?.tgt;
  }
};
